"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _lodash = require("lodash");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    button: {
      margin: theme.spacing(1)
    },
    textField: {
      marginTop: '1rem',
      fontSize: 12
    },
    dialogPaper: {
      minWidth: '20rem',
      minHeight: '30rem'
    }
  };
};
//const languages = [
//  { label: 'French', value: 'French' },
//  { label: 'Spanish', value: 'Spanish' },
//  { label: 'German', value: 'German' },
//  { label: 'Turkish', value: 'Turkish' },
//  { label: 'Italian', value: 'Italian' },
//  { label: 'Portuguese', value: 'Portuguese' },
//  { label: 'Polish', value: 'Polish' },
//  { label: 'British English', value: 'British English' },
//  { label: 'Japanese', value: 'Japanese' },
//  { label: 'Indonesian', value: 'Indonesian'},
//  { label: 'Chinese', value: 'Chinese'},
//  { label: 'Korean', value: 'Korean'},
//  { label: 'Romanian', value: 'Romanian' },
//];
var AnswerTranslation = /*#__PURE__*/function (_Component) {
  function AnswerTranslation(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AnswerTranslation);
    _this = _callSuper(this, AnswerTranslation, [props]);
    var answerItem = props.answerItem;
    _this.state = {
      answerItem: answerItem ? answerItem : {},
      origAnswer: answerItem ? (0, _lodash.cloneDeep)(answerItem) : {},
      selectedLanguage: ''
    };
    ['handleSelectChange', 'handleInputChange', 'onClose'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  // static getDerivedStateFromProps(props, state) {
  //   const { question } = props;
  //   let newState = { ...state };

  //   if (!isEmpty(question) && question.questionID !== state.questionID && props.questionId !== 'new') {
  //     Object.keys(question).forEach((k) => {
  //       newState[k] = question[k];
  //     });
  //   }
  //   return { ...newState };
  // }
  (0, _inherits2["default"])(AnswerTranslation, _Component);
  return (0, _createClass2["default"])(AnswerTranslation, [{
    key: "handleInputChange",
    value: function handleInputChange(answerValue, event) {
      var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
      var _this$state = this.state,
        answerItem = _this$state.answerItem,
        selectedLanguage = _this$state.selectedLanguage;
      var answer = (0, _lodash.find)(answerItem.answers, {
        value: answerValue
      });
      if (!answer.translations) answer.translations = {};
      if (!answer.answerTranslation) answer.answerTranslation = [];
      answer.translations[selectedLanguage.value.description] = value;
      var translation = (0, _lodash.find)(answer.answerTranslation, {
        languageID: selectedLanguage.value.languageID
      });
      if (translation) {
        translation.translation = value;
      } else {
        var t = {
          sourceID: answer.id,
          languageID: selectedLanguage.value.languageID,
          language: selectedLanguage,
          translation: value,
          sourceType: 'Answer'
        };
        answer.answerTranslation.push(t);
      }
      this.setState({
        answerItem: answerItem
      });
    }
  }, {
    key: "handleSelectChange",
    value: function handleSelectChange(value) {
      this.setState({
        selectedLanguage: value
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        answerItem: this.state.origAnswer,
        selectedLanguage: ''
      });
      this.props.onClose();
    }
  }, {
    key: "onConfirm",
    value: function onConfirm() {
      console.log('this.state.answerItem', this.state.answerItem);
      this.props.onConfirm(this.state.answerItem);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        open = _this$props.open,
        languages = _this$props.languages;
      var _this$state2 = this.state,
        selectedLanguage = _this$state2.selectedLanguage,
        answerItem = _this$state2.answerItem;
      var options = languages ? [].concat(languages).reduce(function (all, l) {
        if (l.description !== 'English') all.push({
          label: l.description,
          value: l
        });
        return all;
      }, []) : [];
      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
        classes: {
          paper: classes.dialogPaper
        },
        onClose: this.onClose,
        "aria-labelledby": "simple-dialog-title",
        open: open,
        maxWidth: "lg",
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
        id: "simple-dialog-title"
      }, "Translations"), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
        onChange: this.handleSelectChange,
        value: selectedLanguage,
        name: "language_select",
        options: options,
        placeholder: "Select a Language"
      }), /*#__PURE__*/_react["default"].createElement("br", null), selectedLanguage && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Table, null, /*#__PURE__*/_react["default"].createElement("colgroup", null, /*#__PURE__*/_react["default"].createElement("col", {
        style: {
          width: '50%'
        }
      }), /*#__PURE__*/_react["default"].createElement("col", {
        style: {
          width: '50%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_material.TableHead, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, null, /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, "Description"), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, "Translation"))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, null, answerItem.answers.map(function (r, idx) {
        return /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
          key: idx
        }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, r.label)), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          multiline: true,
          fullWidth: true,
          value: r.translations && r.translations[selectedLanguage.value.description] ? r.translations[selectedLanguage.value.description] : '',
          onChange: function onChange(e) {
            _this2.handleInputChange(r.value, e);
          }
        })));
      }))))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return _this2.onClose();
        }
      }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        form: "theForm",
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return _this2.onConfirm();
        }
      }, "Confirm")));
    }
  }]);
}(_react.Component);
AnswerTranslation.propTypes = {
  onConfirm: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(AnswerTranslation);